import api from '../../features/components/api';

// Get all orders by type
export const getAllOrders = async (type) => {
  try {
    type = type.toUpperCase();
    const response = await api.get(`/orders/fetchall`, {
      params: { type }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to fetch orders';
  }
};

// Accept an order (Wholesaler only)
export const acceptOrder = async (orderId) => {
  try {
    const response = await api.put(`/orders/accept-order/${orderId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to accept order';
  }
};

// Reject an order (Wholesaler only)
export const rejectOrder = async (orderId) => {
  try {
    const response = await api.put(`/orders/reject-order/${orderId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to reject order';
  }
};

// Fetch order by ID
export const fetchOrderById = async (orderId) => {
  try {
    const response = await api.get(`/orders/fetch/${orderId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to fetch order details';
  }
};

// Accept cart (Retailer only)
export const acceptCart = async (orderId) => {
  try {
    const response = await api.put(`/orders/accept-cart/${orderId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to accept cart';
  }
};

// Make new order
export const makeOrder = async (type, orderData) => {
  try {
    const response = await api.post(`/orders/make-order`, orderData, {
      params: { type }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to create order';
  }
};

// Update order
export const updateOrder = async (orderId, orderData) => {
  try {
    const response = await api.put(`/orders/update-order/${orderId}`, orderData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to update order';
  }
};

export const updateCartItem = async (orderId, quantity) => {
  try {
    const response = await api.put(`/orders/update-cart/${orderId}`, { quantity });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to update cart item';
  }
};

export const removeCartItem = async (orderId) => {
  try {
    await api.delete(`/orders/remove-cart/${orderId}`);
    return orderId;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to remove cart item';
  }
};